module.exports = __webpack_public_path__ + "static/media/img2_lat_low.d640aad4.png";